import {
    JOB_YARN_STOCK_REPORT_REQUEST,
    JOB_YARN_STOCK_REPORT_SUCCESS,
    JOB_YARN_STOCK_REPORT_FAILURE,
    JOB_YARN_STOCK_FILTER_REPORT_REQUEST,
    JOB_YARN_STOCK_FILTER_REPORT_SUCCESS,
    JOB_YARN_STOCK_FILTER_REPORT_FAILURE,
  } from "../types/job-yarn-stock-report-types";
  
  const initialState = {
    jobYarnStockReport: {},
    jobYarnStockFilterReport: {},
    loading: false,
    error: null,
  };
  
  const jobYarnStockReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case JOB_YARN_STOCK_REPORT_REQUEST, JOB_YARN_STOCK_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case JOB_YARN_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          jobYarnStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case JOB_YARN_STOCK_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          jobYarnStockFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case JOB_YARN_STOCK_REPORT_FAILURE, JOB_YARN_STOCK_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default jobYarnStockReportReducer;
  